module.exports = __webpack_public_path__ + "img/captcha_background.0f83341e.jpg";